<div class="zeroPadding" *ngFor="let ship of results">
  <div class="row searchResultsRow" (click)="selectShip(ship)">
    <div class="col-md-11">
      <div class="searchResultName">
        <div>{{ ship.shipName }} ({{ ship.shipHull }})</div>
      </div>
      <div class="searchResultDataName">
        Disbo:
        <span class="searchResultDataVal">{{ ship.disboName }}</span>
        | Phone:
        <span class="searchResultdataVal">{{ ship.disboPhone }}</span>
        | DSSN:
        <span class="searchResultdataVal">{{ ship.dssn }}</span>
      </div>
    </div>
  </div>
</div>
